<template lang="pug">
  .banner(v-if="showBanner")
    .banner-image.banner-image
      Flexible.center.text-left.banner-height
        .banner-text
          .text-contain
            h1 Company healthcheck
            br
            p Positive People HR can provide a compliance review to ensure that the basic requirements of employing someone are being met.
            br
            p We can help you develop measures to ensure you are getting the best from your people and can understand how your business is performing in relation to leadership of its people.
            Flexible
              .col
                a(href="https://positivepeoplehr.co.uk/" target="_blank").no-dec
                  Button(type="center") Find out more
              .col
              .col
</template>

<script>
export default {
  computed: {
    showBanner() {
      return this.$route.meta.showBanner;
    }
  },
}
</script>

<style lang="scss">
  .banner {
    width:100%;
    .banner-height {
      height:400px;
    }
    .banner-image {
      width:100%;
      @media all and (min-width:1920px) {
        background-image:url('~@/assets/images/banner-long.jpg');  
      }
      background-image:url('~@/assets/images/banner.jpg');
      background-repeat:no-repeat;
      background-size:cover;
      background-position: center right;
      .banner-text {
        .text-contain {
          max-width:650px;
          padding-left:40px;
        }
        h1,h2,h3,h4,strong,p {
          color:#fff;
        }
      }
    }
  }
</style>